// extracted by mini-css-extract-plugin
export default {"root":"loading__root__TBAR2","spinner":"loading__spinner__ipyZP","rotate":"loading__rotate__vxut2","path":"loading__path__seO1N","dash":"loading__dash__XXheh"};